export default {
    light: {
        primary: '#1565C0',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#BF9002',

        // sidebar
        admin_sidebar_bg: '#21242f',
        admin_sidebar_bg_expanded: '#363b4a',
        admin_sidebar_bg_selected: '#292c38',
        admin_sidebar_text: '#ffffff',
        admin_sidebar_text_selected: '#82B1FF',

        // order_items
        order_sidebar_bg: '#282b38',
        order_sidebar_text: '#ffffff',
        order_sidebar_header_bg: '#282b38',
        order_sidebar_footer_bg: '#1f212b',
        order_sidebar_highlight_bg: '#2e3342',
        order_sidebar_highlight_text: '#ffffff',
        order_sidebar_selected_bg: '#282b38',
        order_sidebar_selected_text: '#82B1FF',
        order_sidebar_border: '#1f212b',

        // table
        table_bg: '#ffffff',
        table_bg_hover: '#eeeeee',
        table_bg_striped: '#fafafa',
        table_bg_highlight: '#2196f3',
    },

    dark: {
        primary: '#1565C0',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#BF9002',

        // sidebar
        admin_sidebar_bg: '#21242f',
        admin_sidebar_bg_expanded: '#363b4a',
        admin_sidebar_bg_selected: '#292c38',
        admin_sidebar_text: '#ffffff',
        admin_sidebar_text_selected: '#82B1FF',

        // order_items
        order_sidebar_bg: '#282b38',
        order_sidebar_text: '#ffffff',
        order_sidebar_header_bg: '#1f212b',
        order_sidebar_footer_bg: '#1f212b',
        order_sidebar_issued_bg: '#2e3342',
        order_sidebar_issued_text: '#ffffff',
        order_sidebar_selected_bg: '#282b38',
        order_sidebar_selected_text: '#82B1FF',
        order_sidebar_border: '#1f212b',

        // table
        table_bg: '#ffffff',
        table_bg_hover: '#eeeeee',
        table_bg_striped: '#fafafa',
        table_bg_highlight: '#2196f3',
    },
}
